import AuthService from './AuthService';

class VectorStoreService {
    constructor() {
        const rawBaseUrl = process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || '';
        this.apiBaseUrl = rawBaseUrl.replace(/\/+$/, '');
        this.vectorStoresPath = '/admin/vectorStores';
    }

    getAuthHeaders(extraHeaders) {
        const token = AuthService.getAccessToken();
        const authHeader = token ? { Authorization: `Bearer ${token}` } : {};
        return {
            ...authHeader,
            ...(extraHeaders || {}),
        };
    }

    sanitizeCreatePayload(payload) {
        const body = { ...(payload || {}) };
        // Let the backend generate the ID.
        delete body.vectorStoreId;
        // Server-managed fields should not be sent from UI.
        delete body.createdAt;
        return body;
    }

    sanitizeUpdatePayload(vectorStoreId, payload) {
        const body = { ...(payload || {}) };
        // Ensure payload matches the URL param to satisfy backend validation.
        body.vectorStoreId = vectorStoreId;
        // Server-managed fields should not be sent from UI.
        delete body.createdAt;
        return body;
    }

    async getVectorStores() {
        const url = `${this.apiBaseUrl}${this.vectorStoresPath}`;
        const response = await fetch(url, {
            method: 'GET',
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }

    async getVectorStore(vectorStoreId) {
        if (!vectorStoreId) throw new Error('vectorStoreId is required');
        const url = `${this.apiBaseUrl}${this.vectorStoresPath}/${encodeURIComponent(vectorStoreId)}`;
        const response = await fetch(url, {
            method: 'GET',
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }

    async createVectorStore(payload) {
        const url = `${this.apiBaseUrl}${this.vectorStoresPath}`;
        const body = this.sanitizeCreatePayload(payload);
        const response = await fetch(url, {
            method: 'POST',
            headers: this.getAuthHeaders({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(body),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }

    async updateVectorStore(vectorStoreId, payload) {
        if (!vectorStoreId) throw new Error('vectorStoreId is required');
        const url = `${this.apiBaseUrl}${this.vectorStoresPath}/${encodeURIComponent(vectorStoreId)}`;
        const body = this.sanitizeUpdatePayload(vectorStoreId, payload);
        const response = await fetch(url, {
            method: 'PUT',
            headers: this.getAuthHeaders({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(body),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    }

    async deleteVectorStore(vectorStoreId) {
        if (!vectorStoreId) throw new Error('vectorStoreId is required');
        const url = `${this.apiBaseUrl}${this.vectorStoresPath}/${encodeURIComponent(vectorStoreId)}`;
        const response = await fetch(url, {
            method: 'DELETE',
            headers: this.getAuthHeaders(),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const text = await response.text();
        try {
            return text ? JSON.parse(text) : { ok: true };
        } catch {
            return { ok: true };
        }
    }
}

const vectorStoreService = new VectorStoreService();
export { VectorStoreService };
export default vectorStoreService;
